/**
 * Tekrarlanabilir "tablo" form alanı — paylaşılan tipler + yardımcılar.
 * Builder kolonları tanımlar (her kolon bir input tipi); doldurmada kullanıcı satır ekler.
 * Değer: data[fieldId] = satır dizisi [{ [colKey]: value }].
 */
export type ColType = "text" | "number" | "select" | "date" | "boolean";
export type TableColumn = { key: string; label: string; type: ColType; options: string[]; unit?: string | null; required: boolean };
export type TableRow = Record<string, unknown>;

export const COL_TYPES: ColType[] = ["text", "number", "select", "date", "boolean"];
export const COL_TYPE_LABEL: Record<ColType, string> = { text: "Metin", number: "Sayı", select: "Seçim", date: "Tarih", boolean: "Evet/Hayır" };

/** Kararlı kolon anahtarı (satır verisi bununla anahtarlanır; kaydetmede korunur). */
export function makeColKey(): string {
  try { return "c" + crypto.randomUUID().replace(/-/g, "").slice(0, 10); } catch { return "c" + Math.random().toString(36).slice(2, 10); }
}

export function blankColumn(): TableColumn {
  return { key: makeColKey(), label: "", type: "text", options: [], unit: null, required: false };
}

/** Kolon tiplerine göre boş bir satır (boolean=false, diğerleri=""). */
export function blankRow(columns: TableColumn[]): TableRow {
  const r: TableRow = {};
  for (const c of columns) r[c.key] = c.type === "boolean" ? false : "";
  return r;
}
